import { render } from "./RevisionMultiple.vue?vue&type=template&id=25e6834a&scoped=true"
import script from "./RevisionMultiple.vue?vue&type=script&lang=js"
export * from "./RevisionMultiple.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./RevisionMultiple.vue?vue&type=style&index=1&id=25e6834a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e6834a"]])

export default __exports__